import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import language from 'kts-platform-frame/entry/Language';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Link } from 'react-router-dom';
import { Card, Input, Icon } from 'antd';
const css = require('./index.scss');
const logHelp = require('./help.png');
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            isSdkReady: false,
        };
    }
    componentDidMount () {

        (function(w:any, d: any, n:any, a?: any, j?:any):any{
            w[n] = w[n] || function () {
                (w[n].a = w[n].a || []).push(arguments);
              };
              j = d.createElement('script');
              j.async = true;
              j.src ='https://qiyukf.com/script/61b5bec5f72b78b7a6bc598344c01c63.js?hidden=1';
              d.body.appendChild(j);
        })(window, document, 'ysf');
        window['ysf']('config', {
            uid: JSON.parse(localStorage['$$/user']).userInfo.cUserId,  // 用户Id
            name: JSON.parse(localStorage['$$/user']).userInfo.nickName,          // 用户名称
            email: JSON.parse(localStorage['$$/user']).userInfo.email, // 用户邮箱
            mobile: JSON.parse(localStorage['$$/user']).userInfo.phone   // 用户电话
        });

        this.setState({
            isSdkReady: true,
        });
    }

    handleContact = () => {
        
        if(this.state.isSdkReady) {
            window['ysf']('open');
            // location.href = ysf('url');
        }else {
            // 仅做参考
            alert('sdk尚未加载成功，请稍后再试');
        }
    }
    render() {
        return (
            <div className={css.info}>
                <div className={css.title}>帮助中心</div>
                <div className={css.content}>
                    <div className={css.contentTitle}>欢迎联系FA TMGP帮助中心</div>
                    <img src={logHelp} className={css.contentIcon} onClick={this.handleContact}/>
                    {/* <p className={css.phoneIcon}><Icon type="phone" />  支持热线 ： 400-836-3566</p> */}
                    {/* <p className={css.emailIcon}> <Icon type="mail" />  支持邮箱： <a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a></p> */}
                    <Link to={`/workbench/myApp`} className={css.goback}>
                        返回我的应用
                    </Link>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/HelpCenter/UI.info.tsx